import * as React from 'react';
// @ts-ignore
import humanparser from 'humanparser';

// @ts-ignore
import AuthActions from 'auth/AuthActions';
import errorLogger from 'utils/errorLogger';
import EventTracking from 'lib/EventTracking';
import LinkDevicePage from 'user/components/LinkDevicePage';
// @ts-ignore
import PromptActions from 'actions/PromptActions';
// @ts-ignore
import { PromptNames } from 'constants/PromptConstants';
import ToastActions from 'actions/ToastActions';
// @ts-ignore
import UserActions from 'user/UserActions';

type Props = {
  deviceType: string;
  deviceUid: string;
  fullName: string;
  onDone: () => void;
  onUserUpdateFailure: () => void;
};

class JoinConfirmDevicePage extends React.Component<Props> {
  triggerTosViewEvent = () => {
    EventTracking.trackKey('tos_and_pp.view');
  };

  handleDeviceConfirmed = (authToken?: string) => {
    const { deviceType, fullName, onDone, onUserUpdateFailure } = this.props;
    const onUserUpdateSuccess = () => {
      onDone();
    };

    const onUserUpdateFailed = () => {
      ToastActions.showErrorToast('An error occurred. Please try again later or contact support.');
      onUserUpdateFailure();
    };

    const onSessionExchanged = () => {
      // bypass the setup sms device setup step, if just added
      if (deviceType === 'phoneNumber') {
        PromptActions.recordDismissal(PromptNames.NUX_SETUP_SMS_DEVICE);
      }

      this.triggerTosViewEvent();
      const humanizedName = humanparser.parseName(fullName);

      // Update the user created during device verification
      UserActions.update({
        prefix: humanizedName.salutation,
        last_name: humanizedName.lastName,
        first_name: humanizedName.firstName,
      }).then(onUserUpdateSuccess, onUserUpdateFailed);
    };

    AuthActions.accessTokenSignIn(authToken)
      .then(onSessionExchanged)
      .catch(errorLogger('JoinConfirmDevicePage handleDeviceConfirm failed'));
  };

  render() {
    const { deviceUid, deviceType } = this.props;
    return (
      <LinkDevicePage
        address={deviceUid}
        deviceType={deviceType}
        onDone={this.handleDeviceConfirmed}
        sendCodeOnInitialRender
      />
    );
  }
}
export default JoinConfirmDevicePage;
